package com.macrofocus.eflux.components

import com.macrofocus.eflux.network.schema.Schema
import com.macrofocus.eflux.ui.PaletteType
import i18next.useTranslation
import js.objects.unsafeJso
import mui.material.Box
import mui.material.Stack
import mui.material.StackDirection
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.responsive
import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML.img
import web.cssom.Auto
import web.cssom.JustifyContent
import web.cssom.pct
import web.cssom.px

external interface SchemaInfoProps : PropsWithChildren {
    var schema: Schema
}

val SchemaInfo = FC<SchemaInfoProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light
    val (t, _) = useTranslation()

    Stack {
        direction = responsive(StackDirection.row)
        asDynamic().justifyContent = JustifyContent.center

//        Typography {
//            variant = TypographyVariant.h1
//
//            +"${props.schema.schemaId}"
//        }
        Box {
            sx = unsafeJso {
                maxWidth = 270.px
                height = 200.px
            }
            img {
                src = "schema/${props.schema.schemaId}.svg"
                alt = "${props.schema.schemaId}"
                style = unsafeJso {
                    width = 100.pct
                    height = Auto.auto
                }
            }
        }
    }
}
